export default __webpack_public_path__ + "static/media/logo_clube_nsc.3519f66e.png";